const LstHeadroom = {

    init: function () {

        LstHeadroom.config = {
            pageHeader: document.getElementById('pageHeader')
        };

        LstHeadroom.setup();

    },

    setup: function () {

        const headroom = new Headroom(LstHeadroom.config.pageHeader, {
            tolerance: {
                up: 5,
                down: 2
            },
            onTop : function() {
                document.body.classList.add('scrolled-to-top');
            },
            onNotTop : function() {
                document.body.classList.remove('scrolled-to-top');
            },
            onBottom : function() {
                document.body.classList.add('scrolled-to-bottom');
            },
            onNotBottom : function() {
                document.body.classList.remove('scrolled-to-bottom');
            }
        });

        headroom.init();

        LstHeadroom.registerEventHandlers();

    },

    registerEventHandlers: function () {

    }

};

document.addEventListener('DOMContentLoaded', function () {
    LstHeadroom.init();
}, {passive: true});
